import RouteBase from '@/router/routes/RouteBase.js';
import { PM_AKADEMI } from '@/constants/urls.constants';

class RoutesPmAkademi {
  subFolderPath = '/pmAkademi';
  isPublic = false;
  title = 'PM Akademi';

  PmAkademi = new RouteBase({
    name: 'pmakademi',
    path: '',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'PmAkademi',
    isPublic: this.isPublic,
    meta: {
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: PM_AKADEMI.DEFAULT_TITLE,
        },
      ],
    },
  });
}

export default new RoutesPmAkademi();
